import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import LayoutFull from '$app-web/layouts/full';

import styles from './styles';

const LayoutFullWithAppBar = ({ classes, wrapper, content, contentWrapperProps, appBar, footer, wrapperProps }) => {
    return (
        <LayoutFull
            wrapper={wrapper}
            wrapperProps={wrapperProps}
            content={
                <>
                    {appBar}
                    <div className={classes.contentWrapper} {...contentWrapperProps}>
                        {content}
                    </div>
                    {footer}
                </>
            }
        />
    );
};

LayoutFullWithAppBar.defaultProps = {
    appBar: null,
    wrapper: null,
    footer: null,
    contentWrapperProps: undefined,
    wrapperProps: undefined,
};

LayoutFullWithAppBar.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    wrapper: PropTypes.elementType,
    content: PropTypes.element.isRequired,
    appBar: PropTypes.oneOfType([PropTypes.element]),
    footer: PropTypes.node,
    contentWrapperProps: PropTypes.oneOfType([PropTypes.object]),
    wrapperProps: PropTypes.oneOfType([PropTypes.object]),
};

export default withStyles(styles)(LayoutFullWithAppBar);
